import React from 'react';

export default function Cart() {
  return (
    <svg
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="11.9678"
        y="15.5234"
        width="13.7514"
        height="10.4848"
        stroke="#83A07B"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M21.4044 15.5234V13.6656C21.4044 12.2506 20.2573 11.1035 18.8423 11.1035V11.1035C17.4273 11.1035 16.2803 12.2506 16.2803 13.6656V15.5234"
        stroke="#83A07B"
        strokeWidth="1.5"
      />
    </svg>
  );
}
